function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:currentColor;fill-rule:evenodd}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "dlookup"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1894",
  "data-name": "Group 1894"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_432",
  d: "M18.908 17.969l-2.7-2.7a6.893 6.893 0 10-.939.94l2.7 2.7a.664.664 0 00.94-.94M5.329 10.89a5.562 5.562 0 115.561 5.562 5.567 5.567 0 01-5.561-5.562",
  className: "cls-2",
  "data-name": "Path 432"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_433",
  d: "M10.866 14.336a2.784 2.784 0 01-2.212-4.475.664.664 0 10-1.054-.808 4.112 4.112 0 003.266 6.612.664.664 0 000-1.329",
  className: "cls-2",
  "data-name": "Path 433",
  transform: "translate(-.315 -.548)"
})));

var SvgLookup = function SvgLookup(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLookup, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lookup.14cc5b92.svg";
export { ForwardRef as ReactComponent };